/**
 * Applies a number mask, allowing digits, a single decimal point, and an optional leading minus sign.
 * @param {string} value - The input string.
 * @returns {string} The masked string.
 */
export function numberMask(value) {
  const strVal = String(value);
  let result = strVal.replace(/[^\d.-]/g, '');

  const dotMatches = result.match(/\./g);
  if (dotMatches && dotMatches.length > 1) {
    const firstDotIndex = result.indexOf('.');
    result = result.substring(0, firstDotIndex + 1) + result.substring(firstDotIndex + 1).replace(/\./g, '');
  }

  const minusMatches = result.match(/-/g);
  if (minusMatches && minusMatches.length > 1) {
    const firstMinusIndex = result.indexOf('-');
    result = result.replace(/-/g, '');
    result = (firstMinusIndex === 0 ? '-' : '') + result;
  }

  return result;
}

/**
 * Applies a pattern mask to a string.
 * @param {string} value - The input string.
 * @param {string} pattern - The mask pattern (e.g., '###-##-####').
 * @returns {string} The masked string.
 */
export function patternMask(value, pattern) {
  const strVal = String(value);
  let result = '';
  let valueIndex = 0;
  const valueChars = strVal.replace(/[^\w\d]/g, '');

  for (const patternChar of pattern) {
    if (valueIndex >= valueChars.length) break;

    const valueChar = valueChars[valueIndex];

    if (patternChar === '#') {
      if (/\d/.test(valueChar)) {
        result += valueChar;
        valueIndex++;
      }
    } else if (patternChar === 'A') {
      if (/[a-zA-Z]/.test(valueChar)) {
        result += valueChar;
        valueIndex++;
      }
    } else if (patternChar === '*') {
      result += valueChar;
      valueIndex++;
    } else {
      result += patternChar;
      if (valueChar === patternChar) {
        valueIndex++;
      }
    }
  }
  return result;
}
